module.exports = __webpack_public_path__ + "img/BRCA3_Mast.7010f08d.png";